export default __webpack_public_path__ + "static/media/MOH_LOGO.f0f6b9ce.png";